import { render, staticRenderFns } from "./SyllabusSave.vue?vue&type=template&id=579126cf&"
import script from "./SyllabusSave.vue?vue&type=script&lang=js&"
export * from "./SyllabusSave.vue?vue&type=script&lang=js&"
import style0 from "./SyllabusSave.vue?vue&type=style&index=0&id=579126cf&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports